
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plan-selection",
      function () {
        return require("private-next-pages/plan-selection.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plan-selection"])
      });
    }
  